import { module } from 'modujs';

export default class extends module {
    init() {
        // Simple module to clone a video and replace the el with this data-module
        // Usefull for autoplay muted video on safari
        if(this.getData('id') !== 'anthem') {
            this.copy();
        }

    }

    copy() {
        const parent = this.el.parentNode;
        const id = this.getData('id');
        const video = document.querySelector(`.js-video-base[data-video-id="${id}"]`).cloneNode(true);
        video.classList.remove('js-video-base');
        video.classList.add('js-video');

        this.$('video')[0].appendChild(video);
        video.play();
        // setTimeout(() => {
            const event = new Event('ready');
            this.el.dispatchEvent(event);
        // },100);
    }

}
